'use client'

import { useEffect } from 'react'
import { whenThirdPartyAllowed } from '@/lib/defer-third-party'

/**
 * GA/gtag — lab’de yok; kullanıcıda etkileşim veya load+3.5s sonrası.
 */
export default function GoogleAnalytics({
  measurementId,
  nonce,
}: {
  measurementId?: string
  nonce?: string
}) {
  const id = (measurementId || '').trim()

  useEffect(() => {
    if (!id || typeof document === 'undefined') return
    let cancelled = false

    void whenThirdPartyAllowed({ fallbackMs: 4_000 }).then(() => {
      if (cancelled || document.getElementById('haber-gtag-js')) return

      const gtag = document.createElement('script')
      gtag.id = 'haber-gtag-js'
      gtag.async = true
      gtag.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
      if (nonce) gtag.nonce = nonce
      document.head.appendChild(gtag)

      const boot = document.createElement('script')
      boot.id = 'haber-ga-bootstrap'
      boot.src = '/ga-bootstrap.js'
      boot.async = true
      if (nonce) boot.nonce = nonce
      document.body.appendChild(boot)
    })

    return () => {
      cancelled = true
    }
  }, [id, nonce])

  if (!id) return null

  return (
    <span id="__HABER_GA_ID" data-id={id} hidden>
      {id}
    </span>
  )
}
